import validator from "validator";

const REQUIRED_TEXT = 'Dit veld is verplicht';

export const validators = {
  baseForm: {
    companyName: value => {
      if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
      return false;
    },
    firstName: value => {
      if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
      return false;
    },
    lastName: value => {
      if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
      return false;
    },
    email: value => {
      if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
      if (!validator.isEmail(value)) return 'Dit is geen geldig e-mail adres';
      return false;
    },
    invoiceEmail: value => {
      if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
      let error = false;
      value.split(',').forEach((email) => {
        if (!validator.isEmail(email)) error = true;
      });
      if (error) {
        return 'Dit is geen geldig e-mail adres';
      }
      return false;
    },
    invoiceStreet: value => {
      if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
      return false;
    },
    invoiceNumber: value => {
      if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
      if (!validator.isNumeric(value)) return 'Dit is geen nummer';
      return false;
    },
    invoicePostcode: value => {
      if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
      return false;
    },
    invoiceCity: value => {
      if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
      return false;
    },
    paymentMethod: value => {
      if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
      if (value !== 'creditcard' && value !== 'directDebit' && value !== 'bankTransfer') return 'Dit is een ongeldige waarde'
      return false;
    },
    invoiceReference: value => {
      if (!validator.isLength(value, { max: 50 })) return 'Dit mag maximaal 50 tekens lang zijn';
      return false;
    },
  },
  // keep key for reference and backwards compatibilty
  creditcard: {
  },
  directDebit: {
    debitOwner: value => {
      if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
      return false;
    },
  },
  bankTransfer: {},
};
